(() => {
  const root = window.Shopify?.routes?.root || '/';
  const initialize = (scope = document) => scope.querySelectorAll('[data-quantity-offers]').forEach(offers => {
    if (offers.dataset.bound) return;
    offers.dataset.bound = 'true';
    const form = offers.closest('form');
    const product = form.closest('[data-product-root]');
    const config = JSON.parse(offers.querySelector('[data-quantity-config]').textContent);
    const optionFields = [...form.querySelectorAll('.visual-options fieldset')];
    config.variants.forEach(variant => {
      const optionImage = optionFields.map(field => {
        const value = variant.options[Number(field.dataset.optionPosition)];
        const input = [...field.querySelectorAll('input')].find(input => input.value === value);
        return input?.closest('label')?.querySelector('img');
      }).find(Boolean);
      if (optionImage) variant.image = optionImage.getAttribute('src');
    });
    const baseSelect = form.querySelector('[data-variant-select]');
    const button = form.querySelector('[data-add-button]');
    const error = form.querySelector('[data-product-error]');
    const quantity = form.querySelector('[name="quantity"]');
    const rows = [...offers.querySelectorAll('[data-quantity-item]')];
    const selectors = rows.map(row => row.querySelector('select'));
    let busy = false;
    let currentBase = baseSelect.value;
    const customizedItems = new Set();
    const count = () => Number(offers.querySelector('input:checked').value);
    const picks = () => selectors.slice(0,count()).map(select => config.variants.find(v => String(v.id) === select.value));
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en',{style:'currency',currency:config.currency}).format(cents/100);
    const update = () => {
      const multiple = count() > 1;
      const panel = offers.querySelector('[data-quantity-selections]');
      const cards = [...offers.querySelectorAll('[data-quantity-card]')];
      cards.find(card => Number(card.dataset.quantityCard) === count()).append(panel);
      panel.hidden = !multiple;
      const base = config.variants.find(v => String(v.id) === baseSelect.value);
      cards.forEach(card => {
        const tier = Number(card.dataset.quantityCard);
        const selected = tier === 1 ? [base] : selectors.slice(0,tier).map(select => config.variants.find(v => String(v.id) === select.value));
        const photo = card.querySelector('[data-quantity-card-photo]');
        const image = photo?.querySelector('img');
        if (image && selected[0]?.image && image.getAttribute('src') !== selected[0].image) {
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src = selected[0].image;
        }
        const total = selected.reduce((sum,v) => sum + (v?.price || 0),0);
        const original = selected.reduce((sum,v) => sum + Math.max(v?.compare || 0,v?.price || 0),0);
        card.querySelector('[data-tier-price]').textContent = money(total);
        const compare = card.querySelector('[data-tier-compare]');
        const saving = card.querySelector('[data-tier-saving]');
        compare.hidden = original <= total;
        compare.textContent = money(original);
        if (saving) {
          saving.hidden = original <= total;
          saving.textContent = `${config.save} ${money(original-total)}`;
        }
        const percent = card.querySelector('[data-tier-percent]');
        if (percent) {
          percent.hidden = original <= total || original <= 0;
          percent.textContent = config.percentOff.replace('[percent]', String(original > 0 ? Math.round((original-total) / original * 100) : 0));
        }
      });
      rows.forEach((row,index) => {row.hidden = !multiple || index >= count(); selectors[index].disabled = row.hidden || busy; const variant = config.variants.find(v => String(v.id) === selectors[index].value); const photo = row.querySelector('[data-quantity-photo]'); photo.replaceChildren(); if (variant?.image) {const image = new Image(46,46); image.src = variant.image; image.alt = ''; photo.append(image);}});
      const visual = form.querySelector('.visual-options');
      const native = form.querySelector('.native-variant');
      if (visual) visual.hidden = multiple;
      native.hidden = multiple || Boolean(visual);
      quantity.hidden = multiple;
      quantity.disabled = multiple;
      if (multiple) {
        const selected = picks(); const ready = selected.every(v => v?.available);
        offers.querySelector('[data-quantity-total]').textContent = money(selected.reduce((sum,v) => sum + (v?.price || 0),0));
        button.disabled = busy || !ready;
        button.textContent = busy ? config.adding : ready ? button.dataset.addLabel : config.unavailable;
        const sticky = product.querySelector('[data-sticky-price]'); if (sticky) sticky.textContent = money(selected.reduce((sum,v) => sum+(v?.price || 0),0));
      } else {
        const v = config.variants.find(v => String(v.id) === baseSelect.value);
        button.disabled = busy || !v?.available; button.textContent = busy ? config.adding : v?.available ? button.dataset.addLabel : button.dataset.soldLabel;
        const sticky = product.querySelector('[data-sticky-price]'); if (sticky && v) sticky.textContent = money(v.price);
      }
      offers.querySelectorAll('input').forEach(input => input.disabled = busy);
    };
    const syncBaseVariant = () => {
      if (currentBase !== baseSelect.value) {
        currentBase = baseSelect.value;
        selectors.forEach((select,index) => {
          if (index === 0 || !customizedItems.has(index)) select.value = currentBase;
        });
      }
      update();
    };
    offers.addEventListener('change', event => {
      error.textContent = '';
      const index = selectors.indexOf(event.target);
      if (index > 0) customizedItems.add(index);
      if (index === 0 && baseSelect.value !== selectors[0].value) {
        baseSelect.value = selectors[0].value;
        const variant = config.variants.find(v => String(v.id) === baseSelect.value);
        form.querySelectorAll('.visual-options fieldset').forEach((field,i) => {
          field.querySelectorAll('input').forEach(input => { input.checked = input.value === variant?.options[i]; });
          const checked = field.querySelector('input:checked');
          const label = field.querySelector('[data-selected-label]');
          if (checked && label) label.textContent = (checked.nextElementSibling?.querySelector('[data-option-caption]')?.textContent || checked.nextElementSibling?.textContent || '').trim();
        });
        baseSelect.dispatchEvent(new Event('change', {bubbles:true}));
      }
      update();
    });
    baseSelect.addEventListener('change', syncBaseVariant);
    form.querySelector('.visual-options')?.addEventListener('change', syncBaseVariant);
    form.addEventListener('submit', async event => {
      if (count() === 1) return;
      event.preventDefault(); event.stopImmediatePropagation();
      if (busy || button.disabled) return;
      const selected = picks();
      if (!selected.every(v => v?.available)) {error.textContent = config.unavailable; return;}
      const items = [...selected.reduce((map,v) => map.set(v.id,(map.get(v.id)||0)+1),new Map())].map(([id,quantity]) => ({id,quantity}));
      busy = true; error.textContent = ''; update();
      try {
        const response = await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || config.error);
        if (document.getElementById('BagDrawer')?.dataset.ready === 'true') document.dispatchEvent(new CustomEvent('pet:cart-added'));
          else location.assign(root + 'cart');
      } catch (failure) {error.textContent = failure.message || config.error;}
      finally {busy = false; update();}
    },true);
    offers.hidden = false; update();
  });
  initialize(); document.addEventListener('shopify:section:load',event => initialize(event.target));
})();
